// import React, { useState } from "react";
// import {
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Typography,
//   FormControl,
//   RadioGroup,
//   Container,
//   Radio,
//   FormControlLabel,
//   Select,
//   MenuItem,
//   Button,
//   TextField,
//   Box,
//   useTheme,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// const StudentReport = () => {
//   const theme = useTheme();

//   // Static data for dropdowns
//   const ddlBatch = [
//     { batchId: 1, batchName: "Batch 1" },
//     { batchId: 2, batchName: "Batch 2" },
//     { batchId: 3, batchName: "Batch 3" },
//   ];
//   const ddlCourse = [
//     { courseId: 1, courseName: "Course 1" },
//     { courseId: 2, courseName: "Course 2" },
//     { courseId: 3, courseName: "Course 3" },
//   ];
//   const ddlStudent = [
//     { studentId: 1, studentName: "Student 1" },
//     { studentId: 2, studentName: "Student 2" },
//     { studentId: 3, studentName: "Student 3" },
//   ];

//   // State for selected values
//   const [selectedBatch, setSelectedBatch] = useState("");
//   const [selectedCourse, setSelectedCourse] = useState("");
//   const [selectedStudent, setSelectedStudent] = useState("");
//   const [fromDate, setFromDate] = useState("2025-09-01");
//   const [toDate, setToDate] = useState("2025-09-30");

//   // Reset all fields
//   const handleReset = () => {
//     setSelectedBatch("");
//     setSelectedCourse("");
//     setSelectedStudent("");
//     setFromDate("2025-09-01");
//     setToDate("2025-09-30");
//   };

//   return (
//     <Container>
//       <Box elevation={3} style={{ padding: "20px", width: "900px", margin: "6px auto" }}>
//         {/* Student Attendance Accordion */}
//         <Accordion>
//           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//             <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//               Student Attendance
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails>
//             <Box display="flex" flexDirection="column" alignItems="flex-start">
//               <Box display="flex" width="100%" gap={2} mb={2}>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedBatch}
//                     onChange={(e) => setSelectedBatch(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Batch
//                     </MenuItem>
//                     {ddlBatch.map((batch) => (
//                       <MenuItem key={batch.batchId} value={batch.batchId}>
//                         {batch.batchName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedCourse}
//                     onChange={(e) => setSelectedCourse(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Course
//                     </MenuItem>
//                     {ddlCourse.map((course) => (
//                       <MenuItem key={course.courseId} value={course.courseId}>
//                         {course.courseName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedStudent}
//                     onChange={(e) => setSelectedStudent(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Student
//                     </MenuItem>
//                     {ddlStudent.map((student) => (
//                       <MenuItem key={student.studentId} value={student.studentId}>
//                         {student.studentName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//               <Box display="flex" alignItems="center" width="100%" mt={2}>
//                 <TextField
//                   id="fromDate"
//                   label="From Date"
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//                 <TextField
//                   id="toDate"
//                   label="To Date"
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//               </Box>
//               <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     mr: 2,
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                     backgroundColor: theme.palette.primary.main,
//                     "&:hover": { backgroundColor: theme.palette.primary.dark },
//                   }}
//                 >
//                   View
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="error"
//                   onClick={handleReset}
//                   sx={{
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Box>
//             </Box>
//           </AccordionDetails>
//         </Accordion>

//         {/* Student Assignment Accordion */}
//         <Accordion>
//           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//             <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//               Student Assignment
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails>
//             <Box display="flex" flexDirection="column" alignItems="flex-start">
//               <Box display="flex" width="100%" gap={2} mb={2}>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedBatch}
//                     onChange={(e) => setSelectedBatch(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Batch
//                     </MenuItem>
//                     {ddlBatch.map((batch) => (
//                       <MenuItem key={batch.batchId} value={batch.batchId}>
//                         {batch.batchName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedCourse}
//                     onChange={(e) => setSelectedCourse(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Course
//                     </MenuItem>
//                     {ddlCourse.map((course) => (
//                       <MenuItem key={course.courseId} value={course.courseId}>
//                         {course.courseName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedStudent}
//                     onChange={(e) => setSelectedStudent(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Student
//                     </MenuItem>
//                     {ddlStudent.map((student) => (
//                       <MenuItem key={student.studentId} value={student.studentId}>
//                         {student.studentName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//               <Box display="flex" alignItems="center" width="100%" mt={2}>
//                 <TextField
//                   id="fromDate"
//                   label="From Date"
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//                 <TextField
//                   id="toDate"
//                   label="To Date"
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//               </Box>
//               <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     mr: 2,
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                     backgroundColor: theme.palette.primary.main,
//                     "&:hover": { backgroundColor: theme.palette.primary.dark },
//                   }}
//                 >
//                   View
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="error"
//                   onClick={handleReset}
//                   sx={{
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Box>
//             </Box>
//           </AccordionDetails>
//         </Accordion>

//         {/* Fees Accordion */}
//         <Accordion>
//           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//             <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//               Fees
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails>
//             <Box display="flex" flexDirection="column" alignItems="flex-start">
//               <Box display="flex" width="100%" gap={2} mb={2}>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedBatch}
//                     onChange={(e) => setSelectedBatch(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Batch
//                     </MenuItem>
//                     {ddlBatch.map((batch) => (
//                       <MenuItem key={batch.batchId} value={batch.batchId}>
//                         {batch.batchName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedCourse}
//                     onChange={(e) => setSelectedCourse(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Course
//                     </MenuItem>
//                     {ddlCourse.map((course) => (
//                       <MenuItem key={course.courseId} value={course.courseId}>
//                         {course.courseName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedStudent}
//                     onChange={(e) => setSelectedStudent(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Student
//                     </MenuItem>
//                     {ddlStudent.map((student) => (
//                       <MenuItem key={student.studentId} value={student.studentId}>
//                         {student.studentName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//               <Box display="flex" alignItems="center" width="100%" mt={2}>
//                 <TextField
//                   id="fromDate"
//                   label="From Date"
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//                 <TextField
//                   id="toDate"
//                   label="To Date"
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//               </Box>
//               <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     mr: 2,
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                     backgroundColor: theme.palette.primary.main,
//                     "&:hover": { backgroundColor: theme.palette.primary.dark },
//                   }}
//                 >
//                   View
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="error"
//                   onClick={handleReset}
//                   sx={{
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Box>
//             </Box>
//           </AccordionDetails>
//         </Accordion>

//         {/* Course Accordion */}
//         <Accordion>
//           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//             <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//               Course
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails>
//             <Box display="flex" flexDirection="column" alignItems="flex-start">
//               <Box display="flex" width="100%" gap={2} mb={2}>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedBatch}
//                     onChange={(e) => setSelectedBatch(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Batch
//                     </MenuItem>
//                     {ddlBatch.map((batch) => (
//                       <MenuItem key={batch.batchId} value={batch.batchId}>
//                         {batch.batchName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedCourse}
//                     onChange={(e) => setSelectedCourse(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Course
//                     </MenuItem>
//                     {ddlCourse.map((course) => (
//                       <MenuItem key={course.courseId} value={course.courseId}>
//                         {course.courseName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl style={{ minWidth: "200px", flex: 1 }}>
//                   <Select
//                     value={selectedStudent}
//                     onChange={(e) => setSelectedStudent(e.target.value)}
//                     displayEmpty
//                   >
//                     <MenuItem value="" disabled>
//                       Select Student
//                     </MenuItem>
//                     {ddlStudent.map((student) => (
//                       <MenuItem key={student.studentId} value={student.studentId}>
//                         {student.studentName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//               <Box display="flex" alignItems="center" width="100%" mt={2}>
//                 <TextField
//                   id="fromDate"
//                   label="From Date"
//                   type="date"
//                   value={fromDate}
//                   onChange={(e) => setFromDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//                 <TextField
//                   id="toDate"
//                   label="To Date"
//                   type="date"
//                   value={toDate}
//                   onChange={(e) => setToDate(e.target.value)}
//                   InputLabelProps={{ shrink: true }}
//                   style={{ marginRight: "10px", flex: 1 }}
//                 />
//               </Box>
//               <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
//                 <Button
//                   variant="contained"
//                   sx={{
//                     mr: 2,
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                     backgroundColor: theme.palette.primary.main,
//                     "&:hover": { backgroundColor: theme.palette.primary.dark },
//                   }}
//                 >
//                   View
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="error"
//                   onClick={handleReset}
//                   sx={{
//                     width: "100px",
//                     height: "50px",
//                     borderRadius: "10px",
//                     padding: "10px 0",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   Reset
//                 </Button>
//               </Box>
//             </Box>
//           </AccordionDetails>
//         </Accordion>
//       </Box>
//     </Container>
//   );
// };

// export default StudentReport;
import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControl,
  RadioGroup,
  Container,
  Radio,
  FormControlLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Box,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StudentReport = () => {
  const theme = useTheme();

  // Static data for dropdowns
  const ddlBatch = [
    { batchId: 1, batchName: "Batch 1" },
    { batchId: 2, batchName: "Batch 2" },
    { batchId: 3, batchName: "Batch 3" },
  ];
  const ddlCourse = [
    { courseId: 1, courseName: "Course 1" },
    { courseId: 2, courseName: "Course 2" },
    { courseId: 3, courseName: "Course 3" },
  ];
  const ddlStudent = [
    { studentId: 1, studentName: "Student 1" },
    { studentId: 2, studentName: "Student 2" },
    { studentId: 3, studentName: "Student 3" },
  ];

  // State for selected values
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [fromDate, setFromDate] = useState("2025-09-01");
  const [toDate, setToDate] = useState("2025-09-30");

  // Reset all fields
  const handleReset = () => {
    setSelectedBatch("");
    setSelectedCourse("");
    setSelectedStudent("");
    setFromDate("2025-09-01");
    setToDate("2025-09-30");
  };

  return (
    <Container>
      <Box elevation={3} style={{ padding: "20px", width: "900px", margin: "6px auto" }}>
        {/* Student Attendance Accordion */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Student Attendance
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box display="flex" width="100%" gap={2} mb={2}>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Batch
                    </MenuItem>
                    {ddlBatch.map((batch) => (
                      <MenuItem key={batch.batchId} value={batch.batchId}>
                        {batch.batchName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Course
                    </MenuItem>
                    {ddlCourse.map((course) => (
                      <MenuItem key={course.courseId} value={course.courseId}>
                        {course.courseName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedStudent}
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Student
                    </MenuItem>
                    {ddlStudent.map((student) => (
                      <MenuItem key={student.studentId} value={student.studentId}>
                        {student.studentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex" alignItems="center" width="100%" mt={2}>
                <TextField
                  id="fromDate"
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
                <TextField
                  id="toDate"
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
                <Button
                  variant="contained"
                  sx={{
                    mr: 2,
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": { backgroundColor: theme.palette.primary.dark },
                  }}
                >
                  View
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Student Assignment Accordion */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Student Assignment
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box display="flex" width="100%" gap={2} mb={2}>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Batch
                    </MenuItem>
                    {ddlBatch.map((batch) => (
                      <MenuItem key={batch.batchId} value={batch.batchId}>
                        {batch.batchName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Course
                    </MenuItem>
                    {ddlCourse.map((course) => (
                      <MenuItem key={course.courseId} value={course.courseId}>
                        {course.courseName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedStudent}
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Student
                    </MenuItem>
                    {ddlStudent.map((student) => (
                      <MenuItem key={student.studentId} value={student.studentId}>
                        {student.studentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex" alignItems="center" width="100%" mt={2}>
                <TextField
                  id="fromDate"
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
                <TextField
                  id="toDate"
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
                <Button
                  variant="contained"
                  sx={{
                    mr: 2,
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": { backgroundColor: theme.palette.primary.dark },
                  }}
                >
                  View
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Fees Accordion */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Fees
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box display="flex" width="100%" gap={2} mb={2}>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Batch
                    </MenuItem>
                    {ddlBatch.map((batch) => (
                      <MenuItem key={batch.batchId} value={batch.batchId}>
                        {batch.batchName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Course
                    </MenuItem>
                    {ddlCourse.map((course) => (
                      <MenuItem key={course.courseId} value={course.courseId}>
                        {course.courseName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedStudent}
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Student
                    </MenuItem>
                    {ddlStudent.map((student) => (
                      <MenuItem key={student.studentId} value={student.studentId}>
                        {student.studentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex" alignItems="center" width="100%" mt={2}>
                <TextField
                  id="fromDate"
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
                <TextField
                  id="toDate"
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
                <Button
                  variant="contained"
                  sx={{
                    mr: 2,
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": { backgroundColor: theme.palette.primary.dark },
                  }}
                >
                  View
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>

        {/* Course Accordion */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Course
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexDirection="column" alignItems="flex-start">
              <Box display="flex" width="100%" gap={2} mb={2}>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedBatch}
                    onChange={(e) => setSelectedBatch(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Batch
                    </MenuItem>
                    {ddlBatch.map((batch) => (
                      <MenuItem key={batch.batchId} value={batch.batchId}>
                        {batch.batchName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedCourse}
                    onChange={(e) => setSelectedCourse(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Course
                    </MenuItem>
                    {ddlCourse.map((course) => (
                      <MenuItem key={course.courseId} value={course.courseId}>
                        {course.courseName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl style={{ minWidth: "200px", flex: 1 }}>
                  <Select
                    value={selectedStudent}
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Student
                    </MenuItem>
                    {ddlStudent.map((student) => (
                      <MenuItem key={student.studentId} value={student.studentId}>
                        {student.studentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box display="flex" alignItems="center" width="100%" mt={2}>
                <TextField
                  id="fromDate"
                  label="From Date"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
                <TextField
                  id="toDate"
                  label="To Date"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  style={{ marginRight: "10px", flex: 1 }}
                  sx={{
                    mb: 3,
                    "& .MuiInputLabel-root": {
                      color: theme.palette.text.primary,
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: theme.palette.primary.main,
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.text.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.primary.main,
                    },
                    "& .MuiInputBase-input[type='date']::-webkit-calendar-picker-indicator": {
                      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
                    },
                  }}
                />
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2} width="100%">
                <Button
                  variant="contained"
                  sx={{
                    mr: 2,
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                    backgroundColor: theme.palette.primary.main,
                    "&:hover": { backgroundColor: theme.palette.primary.dark },
                  }}
                >
                  View
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{
                    width: "100px",
                    height: "50px",
                    borderRadius: "10px",
                    padding: "10px 0",
                    fontWeight: "bold",
                  }}
                >
                  Reset
                </Button>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Container>
  );
};

export default StudentReport;